import i18next from 'i18next';
import { locales } from 'configs/i18n';

/* ------------------------------------- English ------------------------------------- */

i18next.addResources(locales.EN, 'PERSONS_SHOW', {
  TITLE: 'Person',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  LAST_NAME_MOTHER: "Mother's last name",
  ID_CARD_TYPE: 'ID card type',
  ID_CARD: 'ID card',
  EMAIL: 'Email',
  AREA_CODE: 'Area code',
  PHONE: 'Phone',
  CIVIL_STATE: 'Civil state',
  BIRTHDATE: 'Birthdate',
  ADDRESS: 'Address',
  TRIBE: 'Cohen, Levi or Israel',
  COUNTRY: 'Country',
  IMAGE: 'Image',
  COMMENTS: 'Comments',
  ALIVE: 'Is alive?',
  YES: 'Yes',
  NO: 'No',
  CEMENTERY: 'Cementery',
  PERSONS_RELATIONS: 'Personal relations',
  PERSON: 'Person',
  PERSON_STATE: 'Person state',
  PARENTS: 'Parents',
  CHILDS: 'Childs',
  SIBLINGS: 'Siblings',
  GRAND_PARENTS: 'Grand parents',
  DOCUMENTS: 'Documents',
  DOCUMENT_NAME: 'Name',
  DOCUMENT_DATE: 'Date',
  DOCUMENT_TYPE: 'Document type',
  ACTION: 'Action',
  EDIT_DOCUMENT: 'Edit document',
  LOADING: 'Loading...',
});

/* ------------------------------------- Spanish ------------------------------------- */

i18next.addResources(locales.ES, 'PERSONS_SHOW', {
  TITLE: 'Persona',
  FIRST_NAME: 'Nombre',
  LAST_NAME: 'Apellido',
  LAST_NAME_MOTHER: 'Apellido materno',
  ID_CARD_TYPE: 'Tipo de documento',
  ID_CARD: 'Documento',
  EMAIL: 'Email',
  AREA_CODE: 'Código de área',
  PHONE: 'Celular',
  CIVIL_STATE: 'Estado civil',
  BIRTHDATE: 'Fecha de nacimiento',
  ADDRESS: 'Domicilio',
  TRIBE: 'Cohen, Levi o Israel',
  COUNTRY: 'País',
  IMAGE: 'Imagen',
  COMMENTS: 'Observaciones',
  ALIVE: 'Está vivo?',
  CEMENTERY: 'Cementerio',
  YES: 'Si',
  NO: 'No',
  PERSONS_RELATIONS: 'Relaciones personales',
  PERSON: 'Persona',
  PERSON_STATE: 'Estado de la persona',
  PARENTS: 'Padre/Madre',
  CHILDS: 'Hijos/as',
  SIBLINGS: 'Hermanos/as',
  GRAND_PARENTS: 'Abuelos/as',
  DOCUMENTS: 'Documentos',
  DOCUMENT_NAME: 'Nombre',
  DOCUMENT_DATE: 'Fecha',
  DOCUMENT_TYPE: 'Tipo de documento',
  ACTION: 'Acción',
  EDIT_DOCUMENT: 'Editar documento',
  LOADING: 'Cargando...',
});
